import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from '../../../language'
import Button from '../../../utils/components/Button/Button'
import Input from '../../../utils/components/Input/Input'
import circle from '../../../assets/img/circulogris.png';
import './VerifyAccount.css'
import { usePlaces } from '../../../utils/hooks/usePlaces';
import File from '../../../utils/components/File/File'
import localStorage from '../../../utils/hooks/useLocalStorage'



const VerifyAccount = ({
    formik
}) => {
    usePlaces(formik.values.currentCountry, formik.values.currentDepartment)
    const { countries, states, cities } = useSelector(state => state.locations)
    return (
        <div className="">
            <div className="title-register">{Translate('verifyAccount', 'es')}</div>
            <div className="content-verify-account">
                <div className="content-picture-verify-account">
                    {localStorage().getItem("picturProfile") ? <img alt="img" className="img-verify-account" onError={(e) => e.target.src = circle} src={localStorage().getItem("picturProfile")}></img> :
                        <img alt="img" className="img-verify-account" src={circle}></img>}
                </div>
                <div className="content-data-verify-account">
                    <div className="content-inputs-verify-account">
                        <div style={{
                            display: "flex",
                            alignItems: "baseline"
                        }}>
                            <select className='input-select-style' name="identificationType" value={formik.values.identificationType} onChange={formik.handleChange}>
                                <option value="">Tipo identificación</option>
                                <option value="cc">Cédula de ciudadanía</option>
                                <option value="ce">Cédula de extranjería</option>
                                <option value="pa">Pasaporte</option>
                            </select>
                            <Input
                                name="identificationNumber"
                                type="text"
                                placeholder={'*Identificación'}
                                value={formik.values.identificationNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.errors.identificationNumber}

                            />
                        </div>
                        <File
                        accept={".pdf"}
                            name="identificationFile"
                            text={formik.values.identificationFile ? "Archivo cargado" : "*Carge la identificación"}
                            onChange={(event) => formik.setFieldValue("identificationFile", event.target.files[0])}
                        />

                        <div>
                            <select className='input-select-style' name="currentCountry" value={formik.values.currentCountry} onChange={formik.handleChange}>
                                <option value="">País</option>
                                {countries.map((country) => (
                                    <option key={country.countryID} value={country.countryName}>
                                        {country.countryName}
                                    </option>
                                )
                                )}
                            </select>
                        </div>
                        <div>
                            <select className='input-select-style' name="currentDepartment" value={formik.values.currentDepartment} onChange={formik.handleChange}>
                                <option value="">Departamento</option>
                                {states.map((state) => (
                                    <option key={state.stateID} value={state.stateName}>
                                        {state.stateName}
                                    </option>
                                )
                                )}
                            </select>
                        </div>
                        <div>
                            <select className='input-select-style' name="currentCity" value={formik.values.currentCity} onChange={formik.handleChange}>
                                <option value="">Ciudad</option>
                                {cities.map((city) => (
                                    <option key={city.cityID} value={city.cityName}>
                                        {city.cityName}
                                    </option>
                                )
                                )}
                            </select>
                        </div>
                        <Input
                            name="currentLocation"
                            type="text"
                            placeholder={'Barrio'}
                            value={formik.values.currentLocation}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.currentLocation}
                        />
                        <Input
                            name="currentAddress"
                            type="text"
                            placeholder={'Dirección'}
                            value={formik.values.currentAddress}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.currentAddress}
                        />
                    </div>
                    <Button type="submit" onClick={formik.handleSubmit} classNameContent={"button-save-verify-account"} text={Translate('send', 'es')} theme="white" />
                </div>
            </div>
        </div >
    )
}

export default VerifyAccount
